export default {
  withCredentials: true,
  hasToken: false,
  title: '达能集团现渠自动化管理平台',
  logo: require('../assets/image/logo.png'),
  'titleZh': '达能集团现渠自动化管理平台',
  login: {
    'login-logo': require('../assets/image/logo_login.png'),
    // 'haspwd': true,
  },
  menuSearch:true, // 是否开启菜单搜索
  menuMarginLeft: -1,
  reportParamsNumber: 2
}



// WEBPACK FOOTER //
// ./src/_app/wwka/src/config/index.js